













import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  instanceOfIHisInformationApplicable,
} from "../../../../domain/document/items";
import { HisInformationFixedPhrasesMaster } from "../../../../domain/his/master";
import {
  IObject,
  instanceOfIFreeInputableObject,
} from "../objects";
import { CommonComponentsAccessibleMixin } from "../mixins";

@Component
export default class HisInformationFixedPhrasesMenu extends Mixins(CommonComponentsAccessibleMixin) {
  @Prop()
  source: IObject;

  get isVisible(): boolean {
    return (0 < this.phrases.length);
  }

  get isFreeInputable(): boolean {
    return instanceOfIFreeInputableObject(this.source)
        && this.source.isFreeInputable;
  }

  get shouldInputFree(): boolean {
    return instanceOfIFreeInputableObject(this.source)
        && this.source.shouldInputFree;
  }

  get phrases(): string[] {
    const source = this.source.editingSource;
    return (instanceOfIHisInformationApplicable(source) && source.hisItemParameter)
      ? HisInformationFixedPhrasesMaster.getFixedPhrases(source.hisItemParameter.key)
      : [];
  }

  toKey(phrase: string): string {
    return "his-information-fixed-phrases-" + phrase;
  }

  toDescription(phrase: string): string {
    return (!this.shouldInputFree ? "フリー入力にして" : "")
      + "「" + phrase + "」を入力します。";
  }

  async paste(phrase: string): Promise<void> {
    if (instanceOfIFreeInputableObject(this.source)) {
      this.source.pasteText(phrase, true);
    }
  }

  async overwrite(phrase: string): Promise<void> {
    if (instanceOfIFreeInputableObject(this.source)) {
      this.source.overwriteText(phrase, true);
    }
  }
}
